import { Rotationsplan } from '@/domain/mitarbeiter/features/rotationsplan/entities/Rotationsplan';
import { ArbeitsbereichStation } from '@/domain/mitarbeiter/features/rotationsplan/entities/Station';
import { Arbeitsbereich } from '@/domain/mitarbeiter/features/rotationsplan/features/Plaene/components/RotationsplanCard/Arbeitsbereich';
import { Mitarbeiter } from '@/domain/mitarbeiter/features/rotationsplan/features/Plaene/components/RotationsplanCard/Mitarbeiter';
import { Qualifikationen } from '@/domain/mitarbeiter/features/rotationsplan/features/Plaene/components/RotationsplanCard/Qualifikationen';

export function RotationsplanCard({
  rotationsplan,
}: {
  rotationsplan: Rotationsplan;
}) {
  const currentStation = rotationsplan.getCurrentStation();
  const nextStation = rotationsplan.getNextStation();

  return (
    <div className="w-full h-49 bg-white rounded-md p-4 flex flex-col justify-between gap-4">
      <Mitarbeiter rotationsplan={rotationsplan} />
      {currentStation && currentStation instanceof ArbeitsbereichStation && (
        <Arbeitsbereich arbeitsbereichStation={currentStation} />
      )}
      {!currentStation &&
        nextStation &&
        nextStation instanceof ArbeitsbereichStation && (
          <Arbeitsbereich arbeitsbereichStation={nextStation} isNext />
        )}
      <Qualifikationen rotationsplan={rotationsplan} />
    </div>
  );
}
